module.exports = __webpack_public_path__ + "static/media/laboratorio.7870dfa5.svg";